import { memo } from "react";
// @mui

import { Box } from "@mui/material";

// ----------------------------------------------------------------------

function NoChat({ ...other }) {
  return (
    <Box {...other} sx={{ mt: 17, ml: 15 }}>
      <svg
        width="450"
        height="450"
        viewBox="0 0 700 700"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="freepik--background-complete--inject-154">
          <path
            d="M53.33,223.83v47.64a15.61,15.61,0,0,0,15.61,15.61H239.75a15.61,15.61,0,0,0,15.6-15.61V231.22l21.27-22.34L69,208.23A15.61,15.61,0,0,0,53.33,223.83Z"
            fill="#f5f5f5"
          ></path>
          <polygon
            points="230.17 237.09 75.18 236.37 75.19 231.61 230.19 232.32 230.17 237.09"
            fill="#e0e0e0"
          ></polygon>
          <polygon
            points="230.17 252.76 75.18 252.05 75.19 247.28 230.19 248 230.17 252.76"
            fill="#e0e0e0"
          ></polygon>
          <rect
            x="197.14"
            y="234.84"
            width="4.76"
            height="61.33"
            transform="translate(-66.97 463.72) rotate(-89.72)"
            fill="#e0e0e0"
          ></rect>
          <path
            d="M211.6,388.43v47.64a15.61,15.61,0,0,0,15.61,15.61H398a15.61,15.61,0,0,0,15.6-15.61V395.82l21.27-22.34-207.63-.65A15.61,15.61,0,0,0,211.6,388.43Z"
            fill="#f5f5f5"
          ></path>
          <polygon
            points="389.19 400.45 234.19 399.74 234.2 394.97 389.2 395.69 389.19 400.45"
            fill="#e0e0e0"
          ></polygon>
          <polygon
            points="389.19 416.12 234.19 415.41 234.2 410.64 389.2 411.36 389.19 416.12"
            fill="#e0e0e0"
          ></polygon>
          <rect
            x="356.15"
            y="398.2"
            width="4.76"
            height="61.33"
            transform="translate(-72.1 785.28) rotate(-89.72)"
            fill="#e0e0e0"
          ></rect>
          <path
            d="M144.63,44.39H245.37a9,9,0,0,1,9,9v49.27a9,9,0,0,1-9,9H159.89a9,9,0,0,1-9-9V50.62Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M203,92.29v31.6a10.35,10.35,0,0,1-10.35,10.35H79.39A10.36,10.36,0,0,1,69,123.89V97.19L54.94,82.37l137.71-.43A10.35,10.35,0,0,1,203,92.29Z"
            fill="#e0e0e0"
          ></path>
          <polygon
            points="85.74 101.08 188.54 100.61 188.53 97.45 85.73 97.93 85.74 101.08"
            fill="#f5f5f5"
          ></polygon>
          <polygon
            points="85.74 111.48 188.54 111 188.53 107.85 85.73 108.32 85.74 111.48"
            fill="#f5f5f5"
          ></polygon>
          <rect
            x="85.74"
            y="118.35"
            width="40.68"
            height="3.16"
            transform="matrix(1, 0, 0, 1, -0.59, 0.52)"
            fill="#f5f5f5"
          ></rect>
          <path
            d="M417.64,238.8v31.6a10.35,10.35,0,0,1-10.35,10.35H294a10.36,10.36,0,0,1-10.36-10.35V243.7l-14.1-14.82,137.71-.43A10.36,10.36,0,0,1,417.64,238.8Z"
            fill="#e0e0e0"
          ></path>
          <polygon
            points="300.35 247.6 403.16 247.12 403.14 243.96 300.34 244.44 300.35 247.6"
            fill="#f5f5f5"
          ></polygon>
          <polygon
            points="300.35 257.99 403.16 257.52 403.14 254.36 300.34 254.83 300.35 257.99"
            fill="#f5f5f5"
          ></polygon>
          <rect
            x="300.35"
            y="264.86"
            width="40.68"
            height="3.16"
            transform="matrix(1, 0, 0, 1, -1.31, 1.58)"
            fill="#f5f5f5"
          ></rect>
        </g>
        <g id="freepik--Plants--inject-154">
          <path
            d="M320.6,395.65c-16.93-16.49-17.21-42-12.81-64.15.74-3.7,1-7.69,3.28-10.67s6.79-4.53,9.87-2.41c2.55,1.75,3.23,5.16,4.34,8.07a21.94,21.94,0,0,0,7.36,9.76c2.17,1.62,5,2.85,7.52,1.95,3.5-1.25,4.61-5.62,5.19-9.32q1.62-10.36,3.26-20.71c.58-3.71,1.19-7.49,2.91-10.81s4.81-6.17,8.49-6.58,7.7,2.33,7.85,6.08a34.93,34.93,0,0,1-.65,4.62c-.15,1.55.29,3.37,1.68,4s3.06-.13,4.34-1c4.43-3.11,7.81-7.49,11-11.88s6.36-8.91,10.5-12.42,9.45-5.95,14.8-5.38S420,279.56,420.48,285s-3.42,10.23-7.42,13.91a83.87,83.87,0,0,1-19.88,13.58c-1.3.64-2.71,1.32-3.38,2.62-1.21,2.34.73,5.17,3,6.38,2.61,1.37,5.64,1.57,8.47,2.39s5.75,2.59,6.4,5.5c.89,4-2.92,7.47-6.46,9.56a71.68,71.68,0,0,1-22.92,8.66c-2.88.55-5.89.95-8.4,2.51s-4.37,4.66-3.47,7.48,4.16,4.22,7.1,4.16,5.74-1.2,8.63-1.78c5.4-1.08,11.91.34,14.44,5.27,1.67,3.24,1.2,7.29-.45,10.56a27.29,27.29,0,0,1-7.1,8.23c-9.72,8.22-21.41,14.21-33.88,16.37s-23.57,1.48-34.59-4.73"
            fill="#FF725E"
          ></path>
          <path
            d="M317.6,412.13a164.56,164.56,0,0,1,11-29.51,337,337,0,0,1,19-33.54l5.44-8.53c1.79-2.8,3.56-5.58,5.47-8.18A167.55,167.55,0,0,1,370.34,318c4-4.39,7.9-8.4,11.61-12.13s7.23-7.12,10.58-10.08a133,133,0,0,1,16.8-12.8c2.1-1.35,3.76-2.35,4.89-3l1.3-.75A2.73,2.73,0,0,1,416,279a3,3,0,0,1-.42.3l-1.26.8c-1.11.69-2.74,1.72-4.81,3.11a138.87,138.87,0,0,0-16.63,12.94c-3.32,3-6.81,6.39-10.5,10.12s-7.59,7.77-11.54,12.15a169.72,169.72,0,0,0-11.72,14.32c-1.89,2.59-3.65,5.35-5.44,8.15s-3.59,5.65-5.43,8.53a347.12,347.12,0,0,0-19,33.45,167.62,167.62,0,0,0-11.14,29.35"
            fill="#263238"
          ></path>
          <path
            d="M358.74,332.37a8.2,8.2,0,0,1-.1-1.64c0-1.05,0-2.58,0-4.46.08-3.77.37-9,.7-14.71s.56-10.92.58-14.69c0-1.88,0-3.4,0-4.45a7.07,7.07,0,0,1,.06-1.64,8.24,8.24,0,0,1,.21,1.63c.1,1,.17,2.57.22,4.46.1,3.77,0,9-.38,14.73s-.66,10.78-.91,14.69c-.09,1.76-.17,3.25-.24,4.45A7,7,0,0,1,358.74,332.37Z"
            fill="#263238"
          ></path>
          <path
            d="M407.77,331.27a9.72,9.72,0,0,1-1.93-.08c-1.24-.09-3-.24-5.25-.34-4.44-.24-10.57-.36-17.35-.2s-12.9.59-17.33,1c-2.21.2-4,.41-5.23.55a10.31,10.31,0,0,1-1.94.15,10.88,10.88,0,0,1,1.9-.42c1.23-.22,3-.5,5.22-.77,4.43-.56,10.57-1.05,17.37-1.23a170.7,170.7,0,0,1,17.39.41c2.22.17,4,.38,5.25.56A9.89,9.89,0,0,1,407.77,331.27Z"
            fill="#263238"
          ></path>
          <path
            d="M329.37,381.84s-.1-.21-.23-.63-.32-1.11-.54-1.86c-.45-1.61-1.05-4-1.75-6.87-1.4-5.83-3.08-13.93-4.82-22.91s-3.35-17.08-4.63-22.93c-.63-2.84-1.15-5.18-1.53-6.92-.17-.75-.3-1.38-.41-1.89a2.54,2.54,0,0,1-.1-.67,2.27,2.27,0,0,1,.24.64c.14.5.31,1.11.53,1.85.45,1.61,1.05,4,1.75,6.88,1.4,5.82,3.09,13.93,4.82,22.91s3.35,17.08,4.63,22.93c.63,2.84,1.15,5.18,1.53,6.92.17.75.3,1.37.41,1.88A2.63,2.63,0,0,1,329.37,381.84Z"
            fill="#263238"
          ></path>
          <path
            d="M395.92,371.82a2.57,2.57,0,0,1-.67.15l-1.94.32-7.13,1.08c-6,.92-14.31,2.29-23.48,3.8s-17.49,2.81-23.53,3.6c-3,.4-5.47.7-7.16.87l-2,.19a2.22,2.22,0,0,1-.68,0,3.22,3.22,0,0,1,.67-.15l1.93-.32,7.13-1.08c6-.92,14.32-2.28,23.49-3.8s17.49-2.81,23.53-3.6c3-.4,5.46-.7,7.16-.87l2-.18A2.15,2.15,0,0,1,395.92,371.82Z"
            fill="#263238"
          ></path>
          <path
            d="M152.38,170.79a11.13,11.13,0,0,1-3.83-10.5,14.8,14.8,0,0,1,6.36-9.48c1.49-1,3.34-1.84,5.08-1.33a4.78,4.78,0,0,1,3.08,3.72,9.64,9.64,0,0,1-.58,5c-1.9,5.48-4.74,10.44-10.11,12.62"
            fill="#455a64"
          ></path>
          <path
            d="M147.31,180.15a26,26,0,0,0-23-6c-2,.47-4.35,1.55-4.68,3.62s1.51,3.84,3.33,4.9a22.26,22.26,0,0,0,24.61-2"
            fill="#455a64"
          ></path>
          <path
            d="M118,136.81A13.06,13.06,0,0,1,128,138.55a22.92,22.92,0,0,1,7.2,7.52c3.62,5.72,4.9,13.42,5.06,20.19-7.52-.3-13.94-6.21-17-9.42-4.86-5.06-10.56-17.15-5.32-20"
            fill="#455a64"
          ></path>
          <path
            d="M158.68,190.38a27.69,27.69,0,0,1-1.88-2.84,47.66,47.66,0,0,1-4.23-12.07,23.87,23.87,0,0,1,.94-12.73,15.63,15.63,0,0,1,1.81-3.45,4.74,4.74,0,0,1,.93-1.09,33.32,33.32,0,0,0-2.24,4.72,25.18,25.18,0,0,0-.7,12.42,55.55,55.55,0,0,0,4,12"
            fill="#263238"
          ></path>
          <path
            d="M158.75,190.47l-3.92-5.05c-3.29-4.27-7.86-10.16-13-16.6s-9.85-12.2-13.27-16.36l-4-5a13.51,13.51,0,0,1-1.42-1.87,14.92,14.92,0,0,1,1.64,1.68c1,1.12,2.47,2.75,4.24,4.79,3.53,4.08,8.32,9.8,13.46,16.24s9.63,12.39,12.82,16.75c1.6,2.18,2.87,4,3.73,5.19"
            fill="#263238"
          ></path>
          <path
            d="M129,178.58a4.24,4.24,0,0,1,1.3-.4,10,10,0,0,1,1.57-.3,19.19,19.19,0,0,1,2.11-.23,27.47,27.47,0,0,1,5.53.21,31.6,31.6,0,0,1,6.55,1.71,32.13,32.13,0,0,1,6,3.17,27.45,27.45,0,0,1,4.21,3.58,18.8,18.8,0,0,1,1.41,1.59,12.22,12.22,0,0,1,1,1.28c.49.73.42,1.07.38,1.1a44.55,44.55,0,0,0-3.12-3.59,30.78,30.78,0,0,0-4.22-3.38,33.29,33.29,0,0,0-5.87-3,33.78,33.78,0,0,0-6.39-1.73,29.64,29.64,0,0,0-5.4-.36C130.9,178.26,129,178.72,129,178.58Z"
            fill="#263238"
          ></path>
        </g>
        <g id="freepik--speech-bubbles--inject-154">
          <path
            d="M424.23,154.09H198.78a8.81,8.81,0,0,0-8.81,8.82v69.93a8.81,8.81,0,0,0,8.81,8.82h16.8c1.35,7.3,2.93,16.51,2.93,16.51l15.2-16.51H424.23a8.81,8.81,0,0,0,8.81-8.82V162.91A8.81,8.81,0,0,0,424.23,154.09Z"
            fill="#FF725E"
          ></path>
          <path
            d="M331.21,192c0,.14-26.83.26-59.92.26s-59.93-.12-59.93-.26,26.83-.27,59.93-.27S331.21,191.88,331.21,192Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M331.21,181.28c0,.14-26.83.26-59.92.26s-59.93-.12-59.93-.26,26.83-.26,59.93-.26S331.21,181.13,331.21,181.28Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M331.21,202.66c0,.14-26.83.26-59.92.26s-59.93-.12-59.93-.26,26.83-.26,59.93-.26S331.21,202.51,331.21,202.66Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M289.86,213.67c0,.14-17.57.26-39.25.26s-39.25-.12-39.25-.26,17.57-.26,39.25-.26S289.86,213.52,289.86,213.67Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M322.36,279.82H95.07A6.16,6.16,0,0,0,88.9,286v74a6.17,6.17,0,0,0,6.17,6.17H260.15l15,16.33s1.57-9.18,2.9-16.33h44.28a6.17,6.17,0,0,0,6.17-6.17V286A6.16,6.16,0,0,0,322.36,279.82Z"
            fill="#455a64"
          ></path>
          <path
            d="M313.45,318c0,.14-26.83.26-59.93.26s-59.93-.12-59.93-.26,26.83-.26,59.93-.26S313.45,317.82,313.45,318Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M313.45,307.22c0,.14-26.83.26-59.93.26s-59.93-.12-59.93-.26,26.83-.26,59.93-.26S313.45,307.07,313.45,307.22Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M313.45,328.6c0,.14-26.83.26-59.93.26s-59.93-.12-59.93-.26,26.83-.26,59.93-.26S313.45,328.46,313.45,328.6Z"
            fill="#f5f5f5"
          ></path>
          <path
            d="M272.1,339.61c0,.15-17.57.26-39.25.26s-39.26-.11-39.26-.26,17.58-.26,39.26-.26S272.1,339.47,272.1,339.61Z"
            fill="#f5f5f5"
          ></path>
        </g>
        <g id="freepik--character-2--inject-154">
          <path
            d="M367.55,124.43c.14-1.84-1.5-4.37-3-5.83a6,6,0,0,1-1.67-6.37c.61-2.27,2.05-2.1,2.62-3.44a10.16,10.16,0,0,0,.33-3.18,6.64,6.64,0,0,1,7.92-5.64,9.19,9.19,0,0,1,17-1.77A7.07,7.07,0,0,1,401,103.94a5.16,5.16,0,0,1,6.7,1,6.35,6.35,0,0,1,.48,7,8.28,8.28,0,0,1-6,4,12.16,12.16,0,0,1-7.21-1.31,23,23,0,0,1-5.92-4.47"
            fill="#263238"
          ></path>
          <ellipse
            cx="383.9"
            cy="197.07"
            rx="43.29"
            ry="42.28"
            fill="#e0e0e0"
          ></ellipse>
          <path
            d="M427.37,197.1l-4.79-12.28-17.17,10.79,15.3,23.59S426.93,211.12,427.37,197.1Z"
            fill="#eb996e"
          ></path>
          <path
            d="M380,170.5h0a11.52,11.52,0,0,0,11.57-10.89c.25-5.09.47-10,.47-10s9.44-.68,10.31-9.92,1-30.59,1-30.59h0a32.75,32.75,0,0,0-32.9,1.43l-.9.57-1.09,47.8A11.52,11.52,0,0,0,380,170.5Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M385.38,123.32a1.34,1.34,0,1,1-1.72.85A1.36,1.36,0,0,1,385.38,123.32Z"
            fill="#263238"
          ></path>
          <path
            d="M388,123.8c-.16.15-1-.61-2.32-.69s-2.26.52-2.39.35.1-.36.52-.64a3.17,3.17,0,0,1,1.93-.48,3.13,3.13,0,0,1,1.83.75C387.92,123.43,388.05,123.73,388,123.8Z"
            fill="#263238"
          ></path>
          <path
            d="M399.48,123.32a1.34,1.34,0,1,1-1.72.85A1.36,1.36,0,0,1,399.48,123.32Z"
            fill="#263238"
          ></path>
          <path
            d="M402.24,123.82c-.15.16-1-.6-2.32-.68s-2.26.52-2.39.35.1-.36.53-.64a3.12,3.12,0,0,1,1.92-.48,3.19,3.19,0,0,1,1.84.75C402.2,123.46,402.32,123.76,402.24,123.82Z"
            fill="#263238"
          ></path>
          <path
            d="M392.54,133.81a6.21,6.21,0,0,1,2.11-.27c.34,0,.61-.06.65-.24a1.74,1.74,0,0,0-.16-1c-.26-.87-.53-1.75-.81-2.67-1.1-3.8-1.83-6.92-1.64-7s1.25,3,2.35,6.78c.26.92.5,1.81.75,2.68a2.12,2.12,0,0,1,.07,1.4.9.9,0,0,1-.63.49,2.37,2.37,0,0,1-.58,0A6.25,6.25,0,0,1,392.54,133.81Z"
            fill="#263238"
          ></path>
          <path
            d="M392,149.49a21.89,21.89,0,0,1-11.88-4.41s2.33,6.89,11.71,6.81Z"
            fill="#eb996e"
          ></path>
          <path
            d="M369.27,124.68a1.4,1.4,0,0,0-1.32-1.43c-1.74-.08-4.6.55-5,5.31-.52,6.8,6.12,5.23,6.15,5S369.24,127.33,369.27,124.68Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M367.68,130.89s-.13.08-.34.15a1.16,1.16,0,0,1-.89,0,2.93,2.93,0,0,1-1.17-2.74,3.87,3.87,0,0,1,.46-1.67,1.4,1.4,0,0,1,1-.84.6.6,0,0,1,.68.38c.08.19,0,.33.06.34s.16-.1.12-.39a.72.72,0,0,0-.24-.44.91.91,0,0,0-.64-.23,1.68,1.68,0,0,0-1.33,1,3.84,3.84,0,0,0-.56,1.86,3.09,3.09,0,0,0,1.52,3.07,1.32,1.32,0,0,0,1.11-.1C367.65,131.06,367.7,130.91,367.68,130.89Z"
            fill="#eb996e"
          ></path>
          <path
            d="M381.88,120.17c.34.44,1.52.24,3.06.17s2.73-.06,3-.54-1.16-1.63-3.14-1.46S381.5,119.72,381.88,120.17Z"
            fill="#263238"
          ></path>
          <path
            d="M396.86,119.72c.18.59,1.31.77,2.56.76s2.37-.23,2.54-.83-1-1.41-2.57-1.39S396.67,119.14,396.86,119.72Z"
            fill="#263238"
          ></path>
          <path
            d="M404.62,112s-5.61,2.72-12.9-.92c-4.79-2.39-10.36-3.56-11.59-2.6s-1.49,5.9-6.23,7.34c0,0,.32,9.4-3.43,9.07S369.06,110,369.06,110l9.18-4.48,10-1.89,9.43,1.33,7.3,2Z"
            fill="#263238"
          ></path>
          <path
            d="M341.81,166.48c9.81-10.09,27.07-9,27.07-9l14.31,10.25,8.11-9.45a52.75,52.75,0,0,1,16.52,5.11l.55.17v.11c6.28,3.41,15.16,11.59,23.63,19.52l-10.13,9.4-11.22,10a.27.27,0,0,1,0,.2c-.11.61,1.56,14.3,3.28,24.7a42.22,42.22,0,0,1-37.68,11.39c-4.59-.81-6.81-1.92-11.06-3a15.39,15.39,0,0,1-11.39-13.55h0c-.76-8.72-1.34-19.52-1.34-19.52"
            fill="#455a64"
          ></path>
          <path
            d="M400.27,160.05a10.46,10.46,0,0,1,.62,1.61c.37,1,.86,2.57,1.45,4.46,1.18,3.78,2.69,9,4.11,14.93s2.49,11.26,3.16,15.16c.34,2,.59,3.54.74,4.64a11.21,11.21,0,0,1,.19,1.71,10.37,10.37,0,0,1-.39-1.68c-.23-1.17-.53-2.72-.9-4.6-.77-3.88-1.89-9.23-3.31-15.11S403.08,170,402,166.23l-1.3-4.51A12.34,12.34,0,0,1,400.27,160.05Z"
            fill="#263238"
          ></path>
          <path
            d="M409.48,196.1c-.09-.11,4.19-3.75,9.56-8.12s9.79-7.83,9.88-7.72-4.18,3.75-9.55,8.12S409.58,196.21,409.48,196.1Z"
            fill="#263238"
          ></path>
          <path
            d="M354.76,180.32,346,209.19l3.27,1.7,3.22-8.16S355.77,185.57,354.76,180.32Z"
            opacity="0.2"
          ></path>
          <g opacity="0.2">
            <path d="M399.32,160.07c4.73,2.49-7.13,8.49-12.48,8.33l3.89-10.26S397.73,159.23,399.32,160.07Z"></path>
          </g>
          <path
            d="M367.47,158.14v-7.65s14.93,3.85,15.47,12.78c0,0,1.9-9.88,9.6-10.35l1.09,13.89-9,7.8H375.6l-7.19-6.21-.94-9.64"
            fill="#455a64"
          ></path>
          <path
            d="M386.31,206.13a8.74,8.74,0,0,1,0-1.64c0-1.06,0-2.59.05-4.48,0-3.77-.11-9-.58-14.73s-1.23-10.91-1.86-14.63c-.32-1.79-.59-3.27-.79-4.4a9,9,0,0,1-.24-1.63,10.67,10.67,0,0,1,.44,1.59c.26,1,.59,2.52.95,4.38a139.45,139.45,0,0,1,2,14.65,137.87,137.87,0,0,1,.42,14.78c-.05,1.89-.12,3.42-.21,4.48A11.65,11.65,0,0,1,386.31,206.13Z"
            fill="#263238"
          ></path>
          <path
            d="M382.26,160.7a1.76,1.76,0,0,0-.89.08,3.18,3.18,0,0,0-1.5,1.91A43.77,43.77,0,0,0,377,171l-.08.34-.3-.18c-.89-.54-1.81-1.12-2.73-1.74a58.14,58.14,0,0,1-4.84-3.68,6.15,6.15,0,0,1-1.65-2.16,6.78,6.78,0,0,1-.5-2.31,13.43,13.43,0,0,1,.33-3.34,4.93,4.93,0,0,1,.33-1.19,8.15,8.15,0,0,1-.13,1.22,15.56,15.56,0,0,0-.16,3.29,6.27,6.27,0,0,0,.53,2.15,5.71,5.71,0,0,0,1.57,2c1.41,1.18,3.05,2.4,4.81,3.6.92.62,1.82,1.21,2.71,1.75l-.38.16a37.24,37.24,0,0,1,3-8.29,5.88,5.88,0,0,1,.78-1.29,2,2,0,0,1,.95-.65C382,160.44,382.28,160.69,382.26,160.7Z"
            fill="#263238"
          ></path>
          <path
            d="M392.54,152.92a5.4,5.4,0,0,1,.14,1.19l.24,3.26c.11,1.37.28,3,.56,4.79a8.05,8.05,0,0,1,.18,2.94,5.09,5.09,0,0,1-2,2.51,22,22,0,0,0-3.28,2.49l-.4.45,0-.6a17.83,17.83,0,0,0-2.21-7.44c-.95-1.71-1.73-2.58-1.67-2.63s.24.18.59.59a14.64,14.64,0,0,1,1.36,1.88,17.18,17.18,0,0,1,2.43,7.57l-.44-.15a21.11,21.11,0,0,1,3.35-2.58,4.61,4.61,0,0,0,1.78-2.22,8,8,0,0,0-.16-2.74c-.25-1.81-.38-3.46-.45-4.84s-.08-2.5-.07-3.27A4.75,4.75,0,0,1,392.54,152.92Z"
            fill="#263238"
          ></path>
          <path
            d="M440.61,154.84C440,155.55,418,185,418,185l3.1,1.76,22.56-29Z"
            fill="#263238"
          ></path>
          <path
            d="M352.28,178.08s23.13,33.3,24.53,33.95c2.74,1.29,34.38-26.05,37.4-28.67.42-.56,1.28-1.73,3-4.06,0,0,2.5-11.42,5.16-10.55s-1.46,5.81.28,10.15,9.68-6,10-6.94l2.05-2.68s2.15,6.09,2,8.64c-.47,8.15-8.18,17.84-8.18,17.84s-34.63,42.9-58.35,44.23c-6.83.38-19-19-27.09-33.54a19.9,19.9,0,0,1,5.67-25.76Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M432.77,179.36a33.5,33.5,0,0,1,1.48-3,31.26,31.26,0,0,1,1.5-3,18.7,18.7,0,0,1-3,6Z"
            fill="#eb996e"
          ></path>
          <path
            d="M348.37,161.83s-24.83,8.83-6.37,50.58l28.66-17.3-4.08-9.76Z"
            fill="#455a64"
          ></path>
          <path
            d="M346.47,162.56a8.6,8.6,0,0,1,3,.25,12.17,12.17,0,0,1,3.25,1.37,17.47,17.47,0,0,1,3.62,3,43.3,43.3,0,0,1,6.74,10.07c2.1,4.06,4.06,8.69,6.07,13.54.6,1.46,1.2,2.89,1.76,4.25l.09.22-.21.11c-8.29,4.52-15.51,8.75-20.61,11.92-2.56,1.58-4.59,2.88-6,3.78l-1.6,1a3.72,3.72,0,0,1-.58.33,3.24,3.24,0,0,1,.52-.41c.35-.26.87-.64,1.56-1.11,1.36-1,3.37-2.3,5.9-3.92,5.06-3.25,12.26-7.55,20.56-12.08l-.12.32c-.56-1.36-1.16-2.79-1.76-4.25-2-4.85-4-9.47-6-13.52a44.19,44.19,0,0,0-6.58-10,17.68,17.68,0,0,0-3.5-3A12.69,12.69,0,0,0,349.4,163,17.44,17.44,0,0,0,346.47,162.56Z"
            fill="#263238"
          ></path>
          <path
            d="M399.87,100.66a1.43,1.43,0,0,1,.12.44,5.65,5.65,0,0,1,.08,1.29,6.81,6.81,0,0,1-1.9,4.33,6.74,6.74,0,0,1-6.68,1.69,5.88,5.88,0,0,1-3.42-2.48,3.52,3.52,0,0,1-.51-2.26,2.89,2.89,0,0,1,1.23-2.06,2.53,2.53,0,0,1,2.4-.16,3.08,3.08,0,0,1,1.64,1.65,4.4,4.4,0,0,1-.66,4.16,5.21,5.21,0,0,1-6.56,1.42,11.16,11.16,0,0,0-2.47-.94,3,3,0,0,0-1.91.2,9.49,9.49,0,0,0-1.42.94s.09-.13.29-.35a2.61,2.61,0,0,1,.41-.37,3.08,3.08,0,0,1,.64-.41,3.27,3.27,0,0,1,2-.3,11,11,0,0,1,2.57.9,7.59,7.59,0,0,0,1.44.47,4.38,4.38,0,0,0,1.61,0,4.66,4.66,0,0,0,3-1.81,3.91,3.91,0,0,0,.58-3.68,2.37,2.37,0,0,0-3.29-1.26,2.43,2.43,0,0,0-1,1.7,3.06,3.06,0,0,0,.44,1.93,5.43,5.43,0,0,0,3.12,2.28,6.38,6.38,0,0,0,6.28-1.49,6.75,6.75,0,0,0,1.95-4.08A14.24,14.24,0,0,0,399.87,100.66Z"
            fill="#455a64"
          ></path>
          <path
            d="M394.46,138.37c0,.06-.3.2-.85.22a4.49,4.49,0,0,1-3.7-1.86c-.3-.46-.39-.79-.33-.82a11.75,11.75,0,0,0,2.19,1.74A11.59,11.59,0,0,0,394.46,138.37Z"
            fill="#263238"
          ></path>
          <path
            d="M368.24,134c.05,0,.33.44,0,1.13a1.66,1.66,0,0,1-1,.81,1.74,1.74,0,0,1-1.55-.41A1.88,1.88,0,0,1,365,134a2,2,0,0,1,.46-1.2c.48-.56,1-.62,1-.56s-.36.25-.68.78a1.55,1.55,0,0,0,.24,2,1.33,1.33,0,0,0,1.1.33,1.39,1.39,0,0,0,.82-.54C368.26,134.4,368.16,134,368.24,134Z"
            fill="#263238"
          ></path>
          <path
            d="M401.52,104a3.45,3.45,0,0,1,.48,1.84,6.13,6.13,0,0,1-5.56,6.41,3.38,3.38,0,0,1-1.89-.22c0-.09.73,0,1.84-.15a6.18,6.18,0,0,0,5.24-6C401.66,104.74,401.43,104.05,401.52,104Z"
            fill="#455a64"
          ></path>
          <path
            d="M367.7,187.7c.06.13-6.53,3.52-14.73,7.57s-14.89,7.24-15,7.11,6.52-3.52,14.72-7.58S367.64,187.57,367.7,187.7Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M361.69,176.36c.07.12-5.8,3.41-13.11,7.33s-13.29,7-13.35,6.87,5.8-3.41,13.11-7.33S361.62,176.23,361.69,176.36Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M355.88,167.19a23.47,23.47,0,0,1-2.93,1.73l-7.18,4L338.63,177a23.79,23.79,0,0,1-3,1.62,20.06,20.06,0,0,1,2.82-1.93c1.78-1.13,4.27-2.63,7.07-4.22s5.38-2.93,7.27-3.87A19.84,19.84,0,0,1,355.88,167.19Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M377.85,165a4.7,4.7,0,0,1-1.94-.52,15,15,0,0,1-4-2.63,27.84,27.84,0,0,1-3.26-3.54,7.34,7.34,0,0,1-1.13-1.63c.06,0,.58.49,1.41,1.4s1.95,2.15,3.33,3.38a18.2,18.2,0,0,0,3.85,2.68C377.14,164.71,377.87,164.94,377.85,165Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M392.43,159.6a5.52,5.52,0,0,1-2.07,3,5.46,5.46,0,0,1-3.31,1.53,30.83,30.83,0,0,0,3-1.93A35.18,35.18,0,0,0,392.43,159.6Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M418.44,174.65a2.33,2.33,0,0,1-.56.1l-1.61.2c-1.4.16-3.43.35-5.93.55-5,.4-12,.79-19.63,1.07s-14.62.37-19.66.33c-2.51,0-4.55-.07-5.95-.12l-1.62-.08a2.26,2.26,0,0,1-.56-.07,2.2,2.2,0,0,1,.56,0h1.62l5.95-.05c5-.05,12-.21,19.64-.48s14.6-.62,19.62-.92l5.94-.38,1.62-.1A2.11,2.11,0,0,1,418.44,174.65Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M410.54,186.51a12.34,12.34,0,0,1-1.64.26c-1.07.13-2.61.29-4.51.47-3.81.35-9.08.71-14.91.95s-11.12.29-15,.25c-1.91,0-3.46-.06-4.53-.1a9.68,9.68,0,0,1-1.66-.13,11.67,11.67,0,0,1,1.66-.08l4.53-.06c3.82,0,9.1-.17,14.92-.4s11.1-.54,14.91-.8l4.52-.31A9.11,9.11,0,0,1,410.54,186.51Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M392.61,201.13a19.45,19.45,0,0,1-3.31.47c-2.06.21-4.9.44-8.05.6s-6,.21-8.07.2a19.48,19.48,0,0,1-3.34-.13,21,21,0,0,1,3.33-.24l8.05-.35,8-.45A24.75,24.75,0,0,1,392.61,201.13Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M369.7,166.43c0,.15-3.07.18-6.85.34s-6.83.37-6.85.22a51.27,51.27,0,0,1,13.7-.56Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M411.88,165.89a77.47,77.47,0,0,1-8.88.22,75.47,75.47,0,0,1-8.89-.29,76.23,76.23,0,0,1,8.89-.23A73.68,73.68,0,0,1,411.88,165.89Z"
            fill="#e0e0e0"
          ></path>
          <path
            d="M413.42,226.74a4.36,4.36,0,0,1-.91.52c-.6.31-1.49.72-2.6,1.19a57.68,57.68,0,0,1-9,2.87,58.53,58.53,0,0,1-9.34,1.35c-1.2.07-2.18.09-2.86.07a4.31,4.31,0,0,1-1-.07c0-.08,1.48-.14,3.87-.37a73.43,73.43,0,0,0,9.25-1.49,70.45,70.45,0,0,0,9-2.71C412,227.26,413.39,226.66,413.42,226.74Z"
            fill="#e0e0e0"
          ></path>
        </g>
        <g id="freepik--character-1--inject-154">
          <ellipse
            cx="143.29"
            cy="321.55"
            rx="43.29"
            ry="41.3"
            fill="#e0e0e0"
          ></ellipse>
          <path
            d="M134.47,222c-6.86.36-9.56,7.52-10.38,9.12a13.84,13.84,0,0,0-1.1,5.24,11.3,11.3,0,0,1-1.32,5.17c-1.51,2.41-4.69,3.66-5.55,6.37-1,3.07,1.53,6.35.86,9.5-.36,1.69-1.59,3.08-2,4.75a7,7,0,0,0,.93,5.19c2.25,3.88,6.93,5.82,11.41,6s8.86-1.18,13.15-2.5"
            fill="#263238"
          ></path>
          <path
            d="M164.69,230.88a4.3,4.3,0,0,0,1,4.43,27.88,27.88,0,0,0,3.72,3,6.1,6.1,0,0,1,2.54,3.93c.13,1.46-.61,2.92-.41,4.37.52,3.75,6.49,4.87,6.8,8.63.22,2.51-2.36,4.82-1.64,7.23A11.49,11.49,0,0,0,178.2,265c1.7,2.82.55,6.7-1.91,8.88s-5.86,2.95-9.14,3.1c-2.76.12-5.9-.33-7.52-2.56-1.49-2.05-1.18-4.83-.89-7.34,1.39-11.72,1.15-23.56.92-35.36"
            fill="#263238"
          ></path>
          <path
            d="M136.28,285.11c.05-6.16,0-12.64,0-12.64s-7.91-1.41-9.44-11.77c-1.45-9.89,1-31.15,1-31.15h0c11.47-4.53,24.39-2.78,32.42,6.45h0L159,286c-.14,5.8-5.25,10.3-11.46,10.1h0C141.27,295.89,136.23,291,136.28,285.11Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M130,245.87a1.33,1.33,0,0,0,1.26,1.36,1.28,1.28,0,0,0,1.39-1.18,1.34,1.34,0,0,0-1.27-1.36A1.27,1.27,0,0,0,130,245.87Z"
            fill="#263238"
          ></path>
          <path
            d="M127.87,244.85c.16.17,1.17-.56,2.6-.54,2.69.39,2.64.8,2.62.57.08-.07-.08-.39-.54-.72a3.6,3.6,0,0,0-2.09-.68,3.54,3.54,0,0,0-2.08.65C127.94,244.46,127.79,244.77,127.87,244.85Z"
            fill="#263238"
          ></path>
          <path
            d="M144.62,246.3a1.32,1.32,0,0,0,1.26,1.35,1.26,1.26,0,0,0,1.38-1.18,1.33,1.33,0,0,0-1.26-1.36A1.28,1.28,0,0,0,144.62,246.3Z"
            fill="#263238"
          ></path>
          <path
            d="M142.76,245.34c.16.18,1.18-.56,2.6-.54s2.47.75,2.63.58-.09-.39-.54-.73a3.59,3.59,0,0,0-2.1-.67,3.5,3.5,0,0,0-2.08.64C142.83,245,142.68,245.26,142.76,245.34Z"
            fill="#263238"
          ></path>
          <path
            d="M137.45,255.59a8.64,8.64,0,0,0-2.31-.45c-.36,0-.71-.12-.77-.37a1.93,1.93,0,0,1,.26-1.08l1.11-2.76a49.46,49.46,0,0,0,2.51-7.24c-.16-.06-1.54,3.09-3.09,7-.37,1-.72,1.9-1.06,2.78a2.08,2.08,0,0,0-.21,1.43.89.89,0,0,0,.6.54,2,2,0,0,0,.61.09A9.35,9.35,0,0,0,137.45,255.59Z"
            fill="#263238"
          ></path>
          <path
            d="M136.27,272.47a26.34,26.34,0,0,0,13.9-3.53s-3.44,7.07-13.79,6Z"
            fill="#eb996e"
          ></path>
          <path
            d="M138,259a2.59,2.59,0,0,1,2.32-.93A2.36,2.36,0,0,1,142,259a1.5,1.5,0,0,1,.09,1.71,1.75,1.75,0,0,1-1.88.45,5.4,5.4,0,0,1-1.81-1.11,1.63,1.63,0,0,1-.4-.43.47.47,0,0,1,0-.53"
            fill="#eb996e"
          ></path>
          <path
            d="M141.65,256.62c-.24,0-.26,1.54-1.6,2.62s-3,.9-3,1.11.37.31,1.06.33a3.78,3.78,0,0,0,2.51-.84,3.37,3.37,0,0,0,1.23-2.19C141.92,257,141.75,256.61,141.65,256.62Z"
            fill="#263238"
          ></path>
          <path
            d="M155.76,228.62c-3.78,5.4-13.81,10.95-21,12.24.83-1.1,5.24-3.82,6.08-4.92-3.25,2.42-7.91,5.68-12.22,5.89a2.56,2.56,0,0,1-1.49-.23,2,2,0,0,1-.75-1.62,42.66,42.66,0,0,1,.3-9.38,10.35,10.35,0,0,1,3.73-6.69c2.77-2.14,6.72-2.66,10.45-2.75a23.54,23.54,0,0,1,9.21,1.24c2.86,1.12,5.31,3.35,5.73,6"
            fill="#263238"
          ></path>
          <path
            d="M166.62,252.81a57.4,57.4,0,0,0,1-6.92c.31-5.34-1.23-25-19.64-23.46l-.75,5.61s-2.84,19.19,9.07,19.33a21.33,21.33,0,0,0,6,11.28s3.12-.09,4.24-5.84"
            fill="#263238"
          ></path>
          <path
            d="M156.33,247.37a6.28,6.28,0,0,1,3.33.25,4.33,4.33,0,0,1,2.41,2.25,4.53,4.53,0,0,1,0,3.3,7.68,7.68,0,0,1-1.92,2.76,5,5,0,0,1-2,1.31,2.45,2.45,0,0,1-2.3-.38"
            fill="#ffbe9d"
          ></path>
          <path
            d="M156.86,254.09c-.13,0,.35.71,1.36.45a2.12,2.12,0,0,0,1.26-1.08,4.81,4.81,0,0,0,.58-1.82,2.93,2.93,0,0,0-.45-2,1.88,1.88,0,0,0-1.44-.87c-1,0-1.37.68-1.26.7s.49-.28,1.17-.11a1.85,1.85,0,0,1,1.13,2.15c-.13,1.14-.58,2.18-1.19,2.43S156.93,254,156.86,254.09Z"
            fill="#eb996e"
          ></path>
          <path
            d="M158.34,226.6a6.28,6.28,0,0,0,8.49-2.24,4,4,0,0,0,.58-3,4.11,4.11,0,0,0-3.09-2.68,6.33,6.33,0,0,0-5.8,1.39,5.54,5.54,0,0,0-1.5,5.7,5,5,0,0,0,4.77,3.3"
            fill="#263238"
          ></path>
          <path
            d="M160,256.44a15,15,0,0,0-2.86,2.47,4.92,4.92,0,0,0-1.23,3.48,9.45,9.45,0,0,1,.23,2.1,7,7,0,0,1-1.45,2.5,5.93,5.93,0,0,0,.93,6.95,9.62,9.62,0,0,0,6.81,2.76,6.83,6.83,0,0,0,4.18-1c1.72-1.2,2.38-3.46,2.43-5.57"
            fill="#263238"
          ></path>
          <path
            d="M161.26,230.73a6.64,6.64,0,0,1-1.08,1.88,21.06,21.06,0,0,1-3.55,3.88,21.42,21.42,0,0,1-4.37,2.93,7,7,0,0,1-2,.79,46.5,46.5,0,0,0,6.06-4.11A46.7,46.7,0,0,0,161.26,230.73Z"
            fill="#455a64"
          ></path>
          <path
            d="M163.17,230.62a7.87,7.87,0,0,1-.33,2.53,20.76,20.76,0,0,1-2.34,5.69,20.54,20.54,0,0,1-3.93,4.73,8,8,0,0,1-2.08,1.48,31.6,31.6,0,0,0,5.56-6.48A31.19,31.19,0,0,0,163.17,230.62Z"
            fill="#455a64"
          ></path>
          <path
            d="M123.2,239c.15,0,.35,1.72,1,3.77s1.34,3.62,1.2,3.69A11.91,11.91,0,0,1,123.2,239Z"
            fill="#455a64"
          ></path>
          <path
            d="M167.31,274.34a3,3,0,0,0,1.52.49,3.18,3.18,0,0,0,1.76-.56,3.51,3.51,0,0,0,1.33-2,6.35,6.35,0,0,0,0-3c-.21-1.09-.63-2.21-1-3.44a8.92,8.92,0,0,1-.45-4c.23-1.46,1.18-2.65,1.64-4a5.1,5.1,0,0,0-.29-3.95,5.15,5.15,0,0,0-2.74-2.51,17.53,17.53,0,0,1-1.72-.75,3.45,3.45,0,0,1-1.37-1.22,5.85,5.85,0,0,1-.62-3.15,10.77,10.77,0,0,0-.1-2.54,4,4,0,0,0-.75-1.72,2.46,2.46,0,0,0-1.35-.84.93.93,0,0,1,.44,0,2.14,2.14,0,0,1,1.07.66,4.47,4.47,0,0,1,.88,1.79,10.3,10.3,0,0,1,.18,2.61,5.39,5.39,0,0,0,.62,2.91c.56.92,1.72,1.3,2.9,1.77a5.57,5.57,0,0,1,3,2.72,5.64,5.64,0,0,1,.34,4.35c-.52,1.43-1.44,2.57-1.64,3.88a8.58,8.58,0,0,0,.41,3.81c.35,1.2.76,2.35,1,3.48a6.85,6.85,0,0,1-.09,3.2,3.84,3.84,0,0,1-1.53,2.16,3.22,3.22,0,0,1-1.93.52,2.37,2.37,0,0,1-1.2-.39A1,1,0,0,1,167.31,274.34Z"
            fill="#455a64"
          ></path>
          <path
            d="M160.09,273.63s.13.32.61.55a1.64,1.64,0,0,0,1.94-.53,3.06,3.06,0,0,0-.16-3.13c-.57-1.13-1.7-2.24-2-3.89a2.82,2.82,0,0,1,.55-2.31c.49-.6,1.07-1,1.44-1.49a4.36,4.36,0,0,0,.7-3.2,13.44,13.44,0,0,0-.57-2.27,3.34,3.34,0,0,1-.24-.84s.19.26.42.77a9.22,9.22,0,0,1,.75,2.29,4.65,4.65,0,0,1-.67,3.53c-.43.58-1,1-1.42,1.53a2.32,2.32,0,0,0-.45,1.91c.24,1.43,1.3,2.52,1.91,3.75a3.42,3.42,0,0,1,0,3.57,1.78,1.78,0,0,1-1.27.69,1.8,1.8,0,0,1-1.06-.2C160.07,274,160.07,273.62,160.09,273.63Z"
            fill="#455a64"
          ></path>
          <path
            d="M120.89,271a4.56,4.56,0,0,1-.82-.81,10.13,10.13,0,0,1-1.74-2.63,5.17,5.17,0,0,1-.42-2.18,3.85,3.85,0,0,1,.88-2.43c.62-.71,1.52-1.09,2.06-1.76a2.93,2.93,0,0,0,.41-2.57,10.73,10.73,0,0,0-1.09-2.64,9,9,0,0,1-1-2.63,3.44,3.44,0,0,1,.51-2.52,8.62,8.62,0,0,1,1.52-1.59,4.56,4.56,0,0,0,1.71-2.44,3,3,0,0,0,0-1.1s.08.08.15.26a1.82,1.82,0,0,1,.09.87,4.55,4.55,0,0,1-1.66,2.68,9.2,9.2,0,0,0-1.41,1.55,3,3,0,0,0-.4,2.21,8.78,8.78,0,0,0,1,2.47,11.21,11.21,0,0,1,1.15,2.76,3.46,3.46,0,0,1-.52,3c-.68.8-1.58,1.15-2.1,1.76a3.38,3.38,0,0,0-.81,2.12,4.9,4.9,0,0,0,.33,2,10.88,10.88,0,0,0,1.56,2.64A5.94,5.94,0,0,1,120.89,271Z"
            fill="#455a64"
          ></path>
          <path
            d="M162.59,227.9a16.55,16.55,0,0,0-2.44-2.65,16.45,16.45,0,0,0-3.21-1.62,6,6,0,0,1,5.65,4.27Z"
            fill="#FF725E"
          ></path>
          <path
            d="M164,218.33c.06,0,.39.36.66,1.13a5.42,5.42,0,0,1-1.61,5.85c-.64.53-1.12.69-1.15.64s.37-.34.89-.9a5.95,5.95,0,0,0,1.52-5.49A7.31,7.31,0,0,1,164,218.33Z"
            fill="#455a64"
          ></path>
          <path
            d="M113.25,341.34s24.85,23.6,39.62,19.32S172,345.31,172,345.31l.36-4-1.48-1L114,335.77Z"
            opacity="0.30000000000000004"
          ></path>
          <path
            d="M98.56,319.24,103.35,307l17.17,10.79-15.3,23.59S99,333.26,98.56,319.24Z"
            fill="#eb996e"
          ></path>
          <path
            d="M117.93,285.3c8-4.18,18.34-5.38,18.34-5.38h0c3,6,12.47,6.77,18.2,2.67l4.84-3.27a16.77,16.77,0,0,1,2,.09A25.8,25.8,0,0,1,184.19,300a51.39,51.39,0,0,1,1.21,13c-.63,10.93-11.94,11.92-11.94,11.92s-.58,10.79-1.35,19.52h0a16.3,16.3,0,0,1-9.89,14.11,40.28,40.28,0,0,1-12.61,3.89,42.4,42.4,0,0,1-37.59-13c1.72-10.4,3.36-23.87,3.24-24.48a.35.35,0,0,1,0-.2l-11.21-9.95-6.36-5.34s14-20.7,20.22-24.1"
            fill="#FF725E"
          ></path>
          <path
            d="M131.83,292a5.91,5.91,0,0,0-2.77-.77,4.56,4.56,0,0,0-2.86,1,12.26,12.26,0,0,0-1.28,1.37,3.22,3.22,0,0,1-1.81,1.2,2.91,2.91,0,0,1-2.11-.56c-.58-.37-1.07-.77-1.58-1.06a3.43,3.43,0,0,0-2.93-.26,3.81,3.81,0,0,0-1.71,1.18c-.31.39-.42.65-.47.63a1.61,1.61,0,0,1,.31-.75,3.64,3.64,0,0,1,1.74-1.4,3.73,3.73,0,0,1,3.3.18c.56.3,1.06.71,1.61,1.05a2.46,2.46,0,0,0,1.75.48,2.84,2.84,0,0,0,1.53-1,10.5,10.5,0,0,1,1.35-1.4,4.82,4.82,0,0,1,3.16-1,4.63,4.63,0,0,1,2.14.61C131.66,291.78,131.85,292,131.83,292Z"
            fill="#fafafa"
          ></path>
          <path
            d="M143.22,307a5.85,5.85,0,0,0-2.38-1.62,4.63,4.63,0,0,0-3,0,13.54,13.54,0,0,0-1.64.89,3.26,3.26,0,0,1-2.1.56,2.9,2.9,0,0,1-1.82-1.21c-.43-.53-.77-1.07-1.16-1.51a3.43,3.43,0,0,0-2.69-1.18,3.93,3.93,0,0,0-2,.57c-.42.27-.61.48-.65.45s.13-.28.54-.62a3.87,3.87,0,0,1,5.16.46c.43.47.78,1,1.19,1.51a2.53,2.53,0,0,0,1.5,1,2.92,2.92,0,0,0,1.78-.49,10.53,10.53,0,0,1,1.73-.9A4.76,4.76,0,0,1,141,305a4.51,4.51,0,0,1,1.84,1.26C143.14,306.67,143.24,306.94,143.22,307Z"
            fill="#fafafa"
          ></path>
          <path
            d="M168.53,285.1a6,6,0,0,0-2.87-.17,4.57,4.57,0,0,0-2.59,1.58,13,13,0,0,0-.95,1.6,3.29,3.29,0,0,1-1.52,1.57,3,3,0,0,1-2.18-.11c-.64-.24-1.21-.53-1.77-.71a3.44,3.44,0,0,0-2.92.38,3.92,3.92,0,0,0-1.42,1.51c-.22.44-.28.73-.32.72s0-.3.14-.81a3.87,3.87,0,0,1,4.67-2.25c.61.18,1.19.46,1.79.68a2.43,2.43,0,0,0,1.81.1,2.85,2.85,0,0,0,1.28-1.33,10.78,10.78,0,0,1,1-1.65,4.84,4.84,0,0,1,2.89-1.64,4.46,4.46,0,0,1,2.22.15A1.64,1.64,0,0,1,168.53,285.1Z"
            fill="#fafafa"
          ></path>
          <path
            d="M156.85,301.5a5.14,5.14,0,0,0-1.79-1.28,3.44,3.44,0,0,0-2.3-.07,8.81,8.81,0,0,0-1.29.62,2.6,2.6,0,0,1-1.68.37,2.31,2.31,0,0,1-1.4-1c-.31-.43-.55-.86-.83-1.21a2.59,2.59,0,0,0-2-1,3.69,3.69,0,0,0-2.07.65s.1-.22.42-.47a3,3,0,0,1,4,.51c.32.38.58.81.87,1.2a1.87,1.87,0,0,0,1.09.82c.92.16,1.76-.67,2.72-.94a3.72,3.72,0,0,1,2.59.19C156.59,300.52,156.91,301.52,156.85,301.5Z"
            fill="#fafafa"
          ></path>
          <path
            d="M131.1,315.32a5.26,5.26,0,0,0-1.8-1.28A3.44,3.44,0,0,0,127,314a9.32,9.32,0,0,0-1.29.62A2.57,2.57,0,0,1,124,315a2.32,2.32,0,0,1-1.39-1c-.32-.43-.56-.86-.83-1.2a2.62,2.62,0,0,0-2-1,3.61,3.61,0,0,0-2.07.65s.09-.22.42-.47a2.83,2.83,0,0,1,1.65-.55,2.93,2.93,0,0,1,2.37,1.06c.32.38.57.81.87,1.2a1.84,1.84,0,0,0,1.08.82c.92.16,1.77-.67,2.73-.94a3.69,3.69,0,0,1,2.58.19C130.83,314.34,131.15,315.34,131.1,315.32Z"
            fill="#fafafa"
          ></path>
          <path
            d="M155.17,315.64a4.8,4.8,0,0,0-2.11-.64,3.49,3.49,0,0,0-2.2.68,8.76,8.76,0,0,0-1,1,2.61,2.61,0,0,1-1.47.89,2.34,2.34,0,0,1-1.65-.52c-.44-.3-.8-.63-1.18-.87a2.61,2.61,0,0,0-2.21-.29,3.72,3.72,0,0,0-1.75,1.29s0-.24.25-.59a2.87,2.87,0,0,1,1.39-1.05,2.91,2.91,0,0,1,2.58.24c.42.25.8.58,1.21.85a1.82,1.82,0,0,0,1.29.42c.92-.14,1.45-1.2,2.27-1.77a3.76,3.76,0,0,1,2.51-.66A2.66,2.66,0,0,1,155.17,315.64Z"
            fill="#fafafa"
          ></path>
          <path
            d="M147.22,326.62a5.22,5.22,0,0,0-2.11-.64,3.53,3.53,0,0,0-2.21.68,9.6,9.6,0,0,0-1,1,2.59,2.59,0,0,1-1.47.89,2.38,2.38,0,0,1-1.65-.51c-.44-.31-.8-.64-1.18-.87a2.58,2.58,0,0,0-2.21-.3,3.65,3.65,0,0,0-1.75,1.29,1.14,1.14,0,0,1,.24-.59,3,3,0,0,1,4-.81c.43.25.81.58,1.22.85a1.82,1.82,0,0,0,1.29.42c.92-.14,1.45-1.2,2.27-1.77a3.8,3.8,0,0,1,2.51-.66A2.69,2.69,0,0,1,147.22,326.62Z"
            fill="#fafafa"
          ></path>
          <path
            d="M130.43,353.88a5.31,5.31,0,0,0-1.82-1.26,3.46,3.46,0,0,0-2.3,0,9.1,9.1,0,0,0-1.28.65,2.56,2.56,0,0,1-1.67.38,2.3,2.3,0,0,1-1.41-1c-.32-.42-.57-.85-.85-1.19a2.65,2.65,0,0,0-2-1,3.57,3.57,0,0,0-2.06.69s.09-.23.41-.49a2.9,2.9,0,0,1,1.65-.56,2.93,2.93,0,0,1,2.38,1c.32.38.58.81.88,1.19a1.84,1.84,0,0,0,1.1.8c.92.15,1.75-.69,2.71-1a3.74,3.74,0,0,1,2.59.16C130.14,352.9,130.48,353.89,130.43,353.88Z"
            fill="#fafafa"
          ></path>
          <path
            d="M150.08,359.68A5.12,5.12,0,0,0,148,359a3.51,3.51,0,0,0-2.21.65,8.65,8.65,0,0,0-1,1,2.59,2.59,0,0,1-1.48.86,2.3,2.3,0,0,1-1.64-.53c-.44-.31-.8-.65-1.17-.89a2.63,2.63,0,0,0-2.21-.33,3.69,3.69,0,0,0-1.76,1.27s0-.24.25-.58a2.9,2.9,0,0,1,1.4-1,3,3,0,0,1,2.58.28c.42.26.8.59,1.2.87a1.89,1.89,0,0,0,1.29.44c.92-.14,1.47-1.18,2.29-1.74a3.82,3.82,0,0,1,2.52-.63A2.69,2.69,0,0,1,150.08,359.68Z"
            fill="#fafafa"
          ></path>
          <path
            d="M85.32,277c.6.71,22.59,30.11,22.59,30.11l-3.09,1.76-22.57-29Z"
            fill="#263238"
          ></path>
          <path
            d="M171.13,298s-20.62,35.57-22,36.22c-2.75,1.29-34.39-26.06-37.41-28.67-.41-.56-1.27-1.73-3-4.06,0,0-2.49-11.43-5.16-10.55s1.46,5.81-.27,10.15-9.68-6-10-6.94l-2-2.68s-2.15,6.09-2,8.64c.46,8.15,8.17,17.84,8.17,17.84s31.34,39.26,55.06,40.59c6.83.39,19.88-19.28,28-33.82,4.9-8.78,2.62-17.69-5.5-23.62Z"
            fill="#ffbe9d"
          ></path>
          <path
            d="M93.16,301.5a18.7,18.7,0,0,1-3-6c.08,0,.67,1.35,1.5,3S93.23,301.46,93.16,301.5Z"
            fill="#eb996e"
          ></path>
          <path
            d="M170.16,288.06c-.81.49-20,36.09-20,36.09l24.69,19.33a284.27,284.27,0,0,0,9.8-28.67c.92-3.49.45-12.82-.85-16.42-1.84-5.11-4.62-3.84-8.79-6.83Z"
            fill="#FF725E"
          ></path>
          <g opacity="0.7000000000000001">
            <path d="M178.27,288.06s-.24-.14-.7-.37a4.21,4.21,0,0,0-2.17-.45,5.89,5.89,0,0,0-3.22,1.34A15.92,15.92,0,0,0,169,292a55.83,55.83,0,0,0-3,5c-1,1.81-2.14,3.75-3.3,5.79-2.33,4.07-4.9,8.55-7.58,13.25-1.65,2.85-3.24,5.62-4.74,8.22l-.06-.32,16.7,13.2,4.85,3.89,1.28,1.06a2.76,2.76,0,0,1,.43.39,2.81,2.81,0,0,1-.48-.32l-1.34-1-4.94-3.78-16.81-13-.18-.14L150,324c1.5-2.6,3.09-5.37,4.72-8.23,2.7-4.69,5.28-9.15,7.62-13.22l3.34-5.77a55.17,55.17,0,0,1,3-5,15.72,15.72,0,0,1,3.34-3.48,6.14,6.14,0,0,1,3.38-1.32,4.08,4.08,0,0,1,2.23.57,3.89,3.89,0,0,1,.5.33C178.23,288,178.28,288.05,178.27,288.06Z"></path>
          </g>
          <path
            d="M170.9,321.44a5,5,0,0,0-1.79-1.28,3.5,3.5,0,0,0-2.3-.08,8.93,8.93,0,0,0-1.29.63,2.66,2.66,0,0,1-1.68.37,2.31,2.31,0,0,1-1.4-1c-.31-.43-.55-.86-.83-1.21a2.59,2.59,0,0,0-2-1,3.69,3.69,0,0,0-2.07.65s.1-.22.42-.48a3,3,0,0,1,1.66-.54,2.91,2.91,0,0,1,2.36,1.06c.32.38.58.81.87,1.2a1.91,1.91,0,0,0,1.09.82c.92.16,1.76-.67,2.72-.94a3.72,3.72,0,0,1,2.59.18C170.64,320.45,171,321.45,170.9,321.44Z"
            fill="#fafafa"
          ></path>
          <path
            d="M182.18,316.84a4.79,4.79,0,0,0-1.38-1.73,3.53,3.53,0,0,0-2.19-.69,10.67,10.67,0,0,0-1.41.26,2.64,2.64,0,0,1-1.72-.1,2.32,2.32,0,0,1-1.07-1.36c-.18-.5-.3-1-.47-1.38a2.61,2.61,0,0,0-1.66-1.5,3.68,3.68,0,0,0-2.17.07s.15-.19.53-.34a2.79,2.79,0,0,1,1.74-.08,2.93,2.93,0,0,1,2,1.66c.2.45.33.93.51,1.39a1.82,1.82,0,0,0,.83,1.07c.84.41,1.87-.16,2.87-.17a3.81,3.81,0,0,1,2.44.88A2.68,2.68,0,0,1,182.18,316.84Z"
            fill="#fafafa"
          ></path>
          <path
            d="M182.76,302.12a4.91,4.91,0,0,0-1.38-1.72,3.47,3.47,0,0,0-2.19-.69,8.17,8.17,0,0,0-1.41.26,2.58,2.58,0,0,1-1.72-.11,2.33,2.33,0,0,1-1.07-1.35c-.18-.5-.3-1-.47-1.39a2.67,2.67,0,0,0-1.66-1.5,3.68,3.68,0,0,0-2.17.07s.15-.18.53-.34a2.86,2.86,0,0,1,1.74-.08,3,3,0,0,1,2,1.66c.2.45.33.94.51,1.39a1.84,1.84,0,0,0,.83,1.08c.84.4,1.87-.17,2.87-.17a3.7,3.7,0,0,1,2.44.88A2.69,2.69,0,0,1,182.76,302.12Z"
            fill="#fafafa"
          ></path>
          <path
            d="M177.3,336a5.07,5.07,0,0,0-1.38-1.72,3.48,3.48,0,0,0-2.2-.69,8.07,8.07,0,0,0-1.4.26,2.64,2.64,0,0,1-1.72-.1,2.38,2.38,0,0,1-1.07-1.36c-.19-.5-.3-1-.48-1.39a2.65,2.65,0,0,0-1.65-1.5,3.53,3.53,0,0,0-2.17.08s.15-.19.53-.35a3,3,0,0,1,3.73,1.58c.21.45.34.94.52,1.39a1.86,1.86,0,0,0,.82,1.08c.85.4,1.88-.17,2.88-.17a3.7,3.7,0,0,1,2.44.88A2.69,2.69,0,0,1,177.3,336Z"
            fill="#fafafa"
          ></path>
        </g>
      </svg>
    </Box>
  );
}

export default memo(NoChat);
